let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("QKCui")).then(() => parcelRequire('5Hm6Q'));